export default __webpack_public_path__ + "static/media/Banner_Intranet_.f9065244.png";